import React, { useCallback, useContext } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Theme, makeStyles, createStyles } from '@material-ui/core/styles';
import MuiGrid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';

import { ArchivalUnitReference } from 'types';
import { OrderCtx } from 'components/order-ctx/order-ctx';
import { NotificationVariant } from 'components/notification/notification-types';
import { NotificationCtx } from 'components/notification/notification-hook';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    cartRoot: {
      paddingTop: theme.spacing(),
    },
    listItem: {
      padding: 5,
      '&:hover': {
        backgroundColor: 'rgba(207, 41, 49, 0.1)',
      },
    },
    listItemName: {
      flexGrow: 1,
    },
    iconButton: {
      width: 20,
      height: 20,
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.1)',
      },
      '& svg': {
        fontSize: '1rem',
      },
    },
    unitLink: {
      width: '100%',
      color: theme.palette.primary.main,
      display: 'flex',
      alignItems: 'center',
    },
    submitButton: {
      margin: '15px 0',
    },
  })
);

export function GridRightPanelCart() {
  const classes = useStyles();
  const history = useHistory();
  const { showNotification } = useContext(NotificationCtx);
  const { archivalUnits, handleRemoveUnit } = useContext(OrderCtx);

  const removeItemFromCart = useCallback(
    (unit: ArchivalUnitReference) => {
      handleRemoveUnit?.(unit);
      showNotification(
        'Archiválie byla odebrána z košíku.',
        NotificationVariant.INFO,
        3000
      );
    },
    [handleRemoveUnit, showNotification]
  );

  const submitCart = useCallback(async () => {
    history.push('/portfolio/vytvoreni-objednavky');
  }, [history]);

  return (
    <>
      {!!archivalUnits?.length && (
        <MuiGrid container className={classes.cartRoot}>
          <MuiGrid item xs={12}>
            <List
              component="div"
              disablePadding
              dense={true}
              subheader={
                <Typography component="h6" variant="h6">
                  Vaše objednávka
                </Typography>
              }
            >
              {archivalUnits?.map(({ archivalUnitReference: unit, path }) => (
                <ListItem key={unit.id} className={classes.listItem}>
                  <Link to={path} className={classes.unitLink}>
                    <Typography
                      component="span"
                      className={classes.listItemName}
                    >
                      {unit.numericId}
                    </Typography>
                    <IconButton
                      size="small"
                      className={classes.iconButton}
                      onClick={() => removeItemFromCart(unit)}
                    >
                      <ClearIcon />
                    </IconButton>
                  </Link>
                </ListItem>
              ))}
            </List>
          </MuiGrid>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submitButton}
            onClick={submitCart}
          >
            Přejít na objednávku
          </Button>
        </MuiGrid>
      )}
    </>
  );
}
